import React from 'react';
import PropTypes from 'prop-types';

const TextInput = ({ name, label, type = 'text', value = '', onChange, placeholder, error, autoFocus = false, autoComplete = 'off' }) => {
  return (
    <div className='w-full flex flex-col gap-2'>
      {label &&
        <label htmlFor={name} className='text-white'>{label}</label>
      }

      <input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder || label}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        className='block w-full h-12 bg-white/10 bg-opacity-30 text-white rounded-2xl border-white/20 hover:border-white/40 p-3 focus:ring-0 focus:border-white/40 placeholder-white/30 backdrop-blur-sm'
      />
      
      {error && <p>{error}</p>}
    </div>
  );
};

export default TextInput;

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  autoFocus: PropTypes.bool,
  autoComplete: PropTypes.string
}
